import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { useAuth } from '@/middlewares/auth/auth-context'
import { StripeServices } from '@/middlewares/services'
import TranslationNS from '@/utils/Constants/TranslationNS'
import EventHubConfirmDialog from '@/components/EventHub/EventHubConfirmDialog'
import { ORG_BTN_DANGER, ORG_BTN_PRIMARY } from '@/components/Organizer/shared/organizer.ui'

const stripeIntegration = import.meta.env.VITE_STRIPE_INTEGRATION

/**
 * Stripe connection control of the organizer details: "Connect" = the screen's one primary (an ink
 * button, the brand gradient is gone), "Disconnect" = a red text action behind the kit confirm.
 */
const Stripe = ({ user }) => {
    const { t } = useTranslation(TranslationNS.STRIPE)

    const authContext = useAuth()
    const [ask, setAsk] = useState(false)

    const handleDeleteOnConfirm = () => {
        StripeServices.DisconnectStripeAccount(authContext.token).then(() => {
            location.reload()
        })
    }

    if (user.organisation_settings?.stripe?.account_id) {
        return (
            <>
                <button type="button" className={ORG_BTN_DANGER} onClick={() => setAsk(true)}>
                    {t('Disconnect stripe')}
                </button>
                {ask && (
                    <EventHubConfirmDialog
                        title={`${t('Confirm disconnect stripe')} - ${authContext.user.organisation}`}
                        text={t(
                            'Are you sure you want to disconnect your stripe ? Paid registrations would no longer be processed.',
                        )}
                        confirmLabel={t('Disconnect stripe')}
                        cancelLabel={t('Cancel')}
                        onCancel={() => setAsk(false)}
                        onConfirm={() => {
                            setAsk(false)
                            handleDeleteOnConfirm()
                        }}
                    />
                )}
            </>
        )
    }

    return (
        <a href={stripeIntegration} className={`${ORG_BTN_PRIMARY} w-fit no-underline`}>
            {t('Connect stripe')}
        </a>
    )
}

export default Stripe
